var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline text-green-600 border border-green-600 px-2 text-xs ml-2"},[_vm._v("€")])}
var staticRenderFns = []

export { render, staticRenderFns }